/**
 *  价格表
 *  @author FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/09/14      1.0    First version   使用统一的表格组件
 *
 * @copyright 2021-2022, all rights reserved. Essa.cn
 * */

import React from 'react'
import { Spin, Button, message,Input } from 'antd';
import Lang from "@components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import EssaModal from "@/components/EssaModal/EssaModal";
import EditTable from "@/components/EditTable/EditTable";
// import EditTable from "@/components/EditTable/EditTableOpen";
import PropTypes from "prop-types";
import History from "./common/History";
import {toFixed2} from '@utils/utils';
import DownloadBtnModal from "./common/DownloadBtnModal";
import HistoryBtnModal from './common/HistoryBtnModal';
import ConfirmAlert from './common/ConfirmAlert'
import FormFormat from '@components/FormFormat/FormFormat';
import ShipperManagementAction from "../../ShipperManagement.action";
import {getInfo} from "./common/Info";
import PageCommon from  "@components/PageCommon/PageCommon";



const { TextArea } = Input;
export default class PriceListEdit extends React.Component{
    static propTypes = {
        orderType: PropTypes.string.isRequired,
    }
    static defaultProps = {
        orderType:'',
        orderInfo:{
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            list:[],
            orderInfo: {},
            loading:false,
            //历史记录面板
            isShowHistoryPanel:false,
            isShowHistoryId:null,
            // 列
            columns : [
                {
                    cnTitle: '编号',
                    cnTitleId: 'BianHao',
                    width:100,
                    dataIndex: "id",
                    render: (text, item, index) => {
                        return (<span>{index+1}</span>)
                    }
                },
                {
                    cnTitle: '海关编码',
                    width:150,
                    cnTitleId: 'HaiGuanBianMa',
                    dataIndex: "customsCode"
                },
                {
                    cnTitle: '商品编号',
                    width:150,
                    cnTitleId: 'ShangPinBianHao',
                    dataIndex: "skuNo"
                },
                {
                    cnTitle: '俄文品名',
                    cnTitleId: 'ErWenPinMing',
                    dataIndex: "nameRu",
                    width: 350,
                    editable: true,
                    editType:'CopyAndPasteInput',
                    // required:true
                },
                {
                    cnTitle: '英文品名',
                    cnTitleId: 'YinWenPinMing',
                    dataIndex: "nameEn",
                    width:300,
                    editable: true,
                    editType:'CopyAndPasteInput',
                },
                {
                    // cnTitle: '单价',
                    // cnTitleId: 'DanJia',
                    //目前固定此内容不要求国际化
                    title: <div>
                        <p>单价Price per pcs / Цена за шт, USD/ FOB</p>
                        <p className={"color-danger"}>{props.orderInfo.domesticStartPlaceName}</p>
                    </div>,
                    width:250,
                    dataIndex: "price"
                },
            ],
            specialTitle:'Prices for delivery terms / 价格根据交货条款 / FOB', //目前固定此内容不要求国际化
            // 编辑
            editRuOption:[
                {
                    name:'descOne',
                },
                {
                    name:'descTwo',
                    // cnPlaceholder:'价格有效期',
                    // cnPlaceholderId:'JiaGeYouXiaoQi',
                },
            ],
            // 已选 行
            selectList:[],
            showEditModal: false,
            canEdit:false,
            showEditType:'',
            langSkuName:''
        }
    }
    /**
     * 统计
     **/
    count(keyName,list,fixed=0){
        let count = 0;
        for(let i=0;i<list.length;i++){
            let item = list[i];
            count+= Number(item[keyName]);
        }
        return count?count.toFixed(fixed):'-';
    }
    getData(){
        this.onRefTabChildOne.handleFetch(1,{},true)
    }
    /**
     * 展示历史记录面板
     * @param item
     */
    showHistoryPanel(item){
        this.setState({
            isShowHistoryPanel:true,
            isShowHistoryId:item.id,
        })
    }

    /**
     * 隐藏历史记录面板
     **/
    hideHistoryPanel(){
        this.setState({
            isShowHistoryPanel:false,
        })
    }
    /**
     * 加载状态
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 设置 信息头
     * */
    setOrderInfo(res){
        if(res&&res.model&&res.model)this.setState({
            orderInfo:res.model
        })
    }
    /**
     * 编辑
     * */
    edit(flag=true){
        this.setState({
            canEdit: flag,
            selectList:[],
        })
        this.props.handleEdit(flag)
    }
    /**
     * 品名
     * type '1': 俄文， '2': 英文
     * */
    editLang(type){
        const {selectList} = this.state;
        if(selectList.length>0){
            this.setState({
                showEditType:type,
                showEditModal:true,
                langSkuName:'',
            })
        }else message.warning(Lang({id: "QingXuanZeShangPin",default: "请选择商品"}));
    }
    onChangeLangSkuName(e){
        const { target:{value}} = e;
        this.setState({
           langSkuName:value
        })
    }
    updateData = async()=>{
        const { langSkuName,showEditType,selectList } = this.state;
        const allList = await this.onRefEdit.handleGetAllList();//表格行
        if(allList.success){
            let newList = [...allList.data];
            let key = 'nameEn'//英文
            if(showEditType=='1'){//俄文
                key='nameRu'
            }
            selectList.forEach(item=>{
                const hadCurr = newList.find(sku=>sku.id==item.id)
                if(hadCurr&&hadCurr.id) hadCurr[key] = langSkuName
            })
            this.onRefEdit.setNewList(newList,()=>this.flagShowEditModal())
        }else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));

    }
    flagShowEditModal(flag=false){
        this.setState({
            showEditModal:flag,
            showEditType:'',
            langSkuName:'',
        })
    }
    /**
     * 保存
     * */
    async save(){
        const res = await this.onRefFormFormat.handleOK();
        const res2 = await this.onRefEdit.handleGetAllList();//表格行
        if(res.success&&res2.success){
            this.loading(true)
            const { orderInfo } = this.state;
            let postData = { ...res.data} //...orderInfo,
            postData['containerId'] = this.props.containerId;
            postData['priceOrderList'] = res2.data;
            postData['version'] = orderInfo.version;
            ShipperManagementAction.autoFetchAction(postData,'/service/mg/con/report/price-order/save').then(res=>this.handleSaveRes(res.data)).catch(err=>this.handleSaveRes(err))
        }
    }
    handleSaveRes(res){
        this.loading(false)
        const {success,valid} = res;
        if(success&&valid){
            message.success(Lang({id:'CaoZuoChengGong',default: "操作成功",}));
            this.edit(false)
        }else{
            if(res.message){
                message.warning(res.message);
            } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }
    }
    /**
     * 选择
     * */
    rowSelection =  {
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({
                selectList:selectedRows
            })
        },
        onSelect: (record, selected, selectedRows) => {

        },
        onSelectAll: (selected, selectedRows, changeRows) => {

        },
    };
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    onRefEditTable = (ref) =>  this.onRefEdit = ref;
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref; 

    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }

    render(){
        const { orderInfo,loading,columns, isShowHistoryPanel, canEdit,editRuOption,selectList,showEditModal,showEditType,langSkuName,specialTitle} = this.state;
        const {orderType,containerId,downloadUrlExcel,downloadUrlPdf} = this.props;
        const pageTitle = Lang({id: 'JiaGeBiao', default: '价格表'})
        const recoverUrl= '/service/mg/con/report/price-order/recovery-version';//mg-价格表恢复接口 http://rap.essa.top:88/workspace/myWorkspace.do?projectId=170#7419
        let btnList = [];
        if(!isShowHistoryPanel && !canEdit){
            btnList = [
                { 
                    btn: <span>{Lang({id: "BianJi",default: "编辑"})}</span>,
                    icon:"ri-quill-pen-line color-blue mr_4",
                    btnClick:()=>this.edit()
                },{ 
                    btn: <DownloadBtnModal  title={<div>
                        <i className='ri-download-2-line color-blue mr_4'></i>
                        {Lang({id: "XiaZaiExcel",default: "下载Excel"})}
                    </div> }
                    downloadUrl={downloadUrlExcel}
                    orderInfo={orderInfo} />,
                    btnClick:()=>{}
                },{ 
                    btn: <DownloadBtnModal title={<div>
                        <i className='ri-download-2-line color-danger mr_4'></i>
                        {Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                    </div>}
                    downloadUrl={downloadUrlPdf}
                    orderInfo={orderInfo} type={'pdf'} />,
                    btnClick:()=>{}
                },{ 
                    btn: <HistoryBtnModal className={"margin-left-5"}
                    title={Lang({id: 'LiShiJiLu', default: '历史记录'})}
                    orderType={orderType}
                    recoveryHistoryBack={this.getData.bind(this)}
                    showHistoryPanel={item=>this.showHistoryPanel(item)}
                    containerId={containerId} />,
                    btnClick:()=>{}
                }
            ]
    
            if(orderInfo.status === '10' || orderInfo.status === '20'){
                btnList.push({
                    btn: <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} />,
                    btnClick:()=>{}
                })
            }
        }


        return (
            <PageCommon onRef={this.onRefPageCommon} className={"transferWrap"} btnList={btnList}>
                <div className={"packListWrap"}>
                    {isShowHistoryPanel?<History id={this.state.isShowHistoryId} orderType={orderType}
                                                title={pageTitle}
                                                type={'2'} // 类型2目的为显示 不一样的orderInfo结构
                                                loading={loading}
                                                columns = {columns}
                                                recoverUrl={recoverUrl}
                                                showRecover={true}
                                                scroll={{ x:1300, y:300}}
                                                callBackFields = {['model','priceOrderList']}
                                                fetchApi={'/service/mg/con/report/price-order/details'}
                                                callBack={this.hideHistoryPanel.bind(this)} />:<Spin spinning={loading}>

                        {canEdit?<div>
                            {/* 编辑内容 */}
                            <EditTable columns={columns}
                                    onRef={this.onRefEditTable}
                                    rowSelection={this.rowSelection}
                                    callBackFields = {['model','priceOrderList']}
                                    paginationFlag={false}
                                    bordered={true}
                                    rowClassName={(record, index)=>{return record.isSign?"is-sign-bg":""}}
                                    scroll={{ x:1300}}
                                    fetchCallBack={(res)=>this.setOrderInfo(res)}
                                    precondition={{containerId:containerId}}
                                    fetchApi={'/service/mg/con/report/price-order/details'} >
                                {/* 表头 公司名称英文、中文、地址、注释*/}
                                <div  className="padding-top-10 padding-bottom-10 bar">
                                    <div className={"text-center"}>
                                        <p className={"font-20 padding-top-10 padding-bottom-10 color-black"}>{orderInfo.companyNameEn}</p>
                                        {/*<p>{orderInfo.companyNameZh}</p>*/}
                                    </div>
                                    <div className="border-bottom padding-top-10 padding-bottom-10">
                                        {orderInfo.companyAddress}
                                    </div>
                                    <div className="padding-top-10 padding-bottom-10">
                                        <FormFormat onRef={this.onRefForm}
                                                    options={editRuOption}
                                                    formLayout = "vertical"
                                                    className={'form-format-white'}
                                                    initialValues={orderInfo} />
                                    </div>
                                </div>
                                {/* 表头 END */}
                                {/* 特别的标题 显示交货条款 */}
                                <div className={"color-black padding-bottom-10 font-bold"}>{specialTitle}
                                    <span className={"margin-left-5 color-danger"}>{orderInfo.domesticStartPlaceName}</span>
                                </div>
                            </EditTable>
                            <div className={"padding-top-10"}>
                                <span>{Lang({id: "YiXuanZeNKuan",default: `已选择{0}款`,params:[selectList.length]})}</span>
                                <Button className={"margin-left-5"} onClick={()=>this.editLang('1')}>{Lang({id: "PiLiangBianJiEWenPinMing",default: "批量编辑俄文品名"})}</Button>
                                <Button className={"margin-left-5"} onClick={()=>this.editLang('2')}>{Lang({id: "PiLiangBianJiYingWenPinMing",default: "批量编辑英文品名"})}</Button>
                            </div>
                            <div className={"padding-top-10 text-center"}>
                                <Button type="primary" onClick={()=>this.save()}>{Lang({id: "QueDing",default: "确定"})}</Button>
                                <Button className={"margin-left-5"} onClick={()=>this.edit(false)}>{Lang({id: "QuXiao",default: "取消"})}</Button>
                            </div>
                        </div>:<AutoFetchTable columns={columns}
                                                    onRef={this.onRefTabOne}
                                                    callBackFields = {['model','priceOrderList']}
                                                    paginationFlag={false}
                                                    bordered={true}
                                                    rowClassName={(record, index)=>{return record.isSign?"is-sign-bg":""}}
                                                    scroll={{ x:1300}}
                                                    fetchCallBack={(res)=>this.setOrderInfo(res)}
                                                    precondition={{containerId:containerId}}
                                                    fetchApi={'/service/mg/con/report/price-order/details'} >
                            {/* 预览内容 */}
                            {orderInfo&&orderInfo.id&&<div>
                                {/*操作区*/}
                                <div className={"flex-item fixed-footer__wrap"}>
                                    {/* <Button onClick={()=>this.edit()}>{Lang({id: "BianJi",default: "编辑"})}</Button>
                                    <DownloadBtnModal title={Lang({id: "XiaZaiExcel",default: "下载Excel"})}
                                                    className={"margin-left-5"}
                                                    downloadUrl={downloadUrlExcel}
                                                    orderInfo={orderInfo} />
                                    <DownloadBtnModal title={Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                                                    type={'pdf'}
                                                    className={"margin-left-5"}
                                                    downloadUrl={downloadUrlPdf}
                                                    orderInfo={orderInfo} />
                                    <HistoryBtnModal className={"margin-left-5"}
                                                    title={pageTitle+Lang({id: 'LiShiJiLu', default: '历史记录'})}
                                                    orderType={orderType}
                                                    recoverUrl={recoverUrl}
                                                    showRecover={true}
                                                    recoveryHistoryBack={this.getData.bind(this)}
                                                    showHistoryPanel={item=>this.showHistoryPanel(item)}
                                                    containerId={containerId} />
                                    <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} /> */}
                                </div>
                                {/* 表头 公司名称英文、中文、地址、注释*/}
                                {getInfo(orderType,orderInfo)}
                                {/* 表头 END */}
                                {/* 特别的标题 显示交货条款 */}
                                <div className={"color-black padding-bottom-10 font-bold"}>{specialTitle}
                                    <span className={"margin-left-5 color-danger"}>{orderInfo.domesticStartPlaceName}</span>
                                </div>
                            </div>}
                        </AutoFetchTable>}
                        {showEditModal&&<EssaModal title={showEditType=='1'?Lang({id: "PiLiangBianJiEWenPinMing",
                            default: "批量编辑俄文品名"}):Lang({id: "PiLiangBianJiYingWenPinMing",
                            default: "批量编辑英文品名"})}
                                                open={showEditModal}
                                                    width={500}
                                                    onOk={()=>this.updateData()}
                                                    onCancel={()=>this.flagShowEditModal(false)}>
                            <p><span>{Lang({id: "YiXuanZeNKuan",default: `已选择{0}款`,params:[selectList.length]})}</span></p>
                            <TextArea rows={2} value={langSkuName}  onChange={(e)=>this.onChangeLangSkuName(e)}/>
                        </EssaModal>}
                    </Spin>}
                </div>
            </PageCommon>
        )
    }
}
